export default {
  tagline: 'Herní klíče, doručené férově. Zažijte nový standard digitální distribuce.',
  shop: 'OBCHOD',
  legal: 'PRÁVNÍ',
  help: 'NÁPOVĚDA',
  marketplace: 'Tržiště',
  catalog: 'Katalog',
  articles: 'Články',
  terms: 'Podmínky',
  privacy: 'Soukromí',
  cookies: 'Cookies',
  support: 'Podpora',
  faq: 'FAQ',
  language: 'Jazyk',
  legalLine:
    'PlayStock Placeholder Ltd. Placeholder adresa, Riga, Lotyšsko · DIČ: LV40012345678 · Reg. č.: 40012345678',
  copyright: '© 2026 PlayStock. Herní klíče, doručené férově.',
};
